export const SCREEN_SHARING_STREAM_NAME = 'screen'
export const WEBCAM_STREAM_NAME = 'video'
export const SIP_SUBSCRIBE_EXPIRES_DEFAULT_SECONDS = 60
